import * as React from 'react';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var IconReorder = function IconReorder(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.33203 5.79639L12.8728 5.7895",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7656 9.4729L8.71317 5.79583L12.7656 2.11876",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7246 13.8376C4.7246 15.4284 5.19631 16.9834 6.08008 18.3061C6.96386 19.6287 8.22 20.6596 9.68966 21.2684C11.1593 21.8771 12.7765 22.0364 14.3367 21.7261C15.8969 21.4157 17.33 20.6497 18.4548 19.5249C19.5796 18.4001 20.3457 16.9669 20.656 15.4067C20.9663 13.8466 20.8071 12.2294 20.1983 10.7597C19.5896 9.29007 18.5587 8.03393 17.236 7.15015C15.9134 6.26638 14.3583 5.79467 12.7676 5.79467",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
};

export { IconReorder };